import ContactsListPageController from './controllers/pages/list';
import ContactsDetailsOverviewPageController from './controllers/pages/details/overview';
import ContactsDetailsDocumentsPageController from './controllers/pages/details/documents';
import ContactsDetailsInvoicesPageController from './controllers/pages/details/invoices';
import ContactsDetailsRsvpsPageController from './controllers/pages/details/rsvps';
import ContactsDetailsMessagesPageController from './controllers/pages/details/messages';
import ContactsDetailsChangelogPageController from './controllers/pages/details/changelog';
import ContactsDetailsCheckInsPageController from './controllers/pages/details/checkins';
import ContactsImportPageController from './controllers/pages/import';
import ContactsChangelogPageController from './controllers/pages/changelog';
import ContactsEditPageController from './controllers/pages/details/edit';
import ContactsCreatePageController from './controllers/pages/create';
import ContactsMultipleEditPageController from './controllers/pages/multi-edit-controller';
import ContactsDuplicatePageController from './controllers/pages/duplicate';
import ContactsDuplicatesPageController from "./controllers/pages/duplicates";

import listTemplateUrl from './views/pages/list.tpl.html';
import detailsBaseTemplateUrl from './views/pages/details/base.tpl.html';
import detailsOverviewTemplateUrl from './views/pages/details/overview.tpl.html';
import detailsDocumentsTemplateUrl from './views/pages/details/documents.tpl.html';
import detailsRsvpsTemplateUrl from './views/pages/details/rsvps.tpl.html';
import detailsInvoicesTemplateUrl from './views/pages/details/invoices.tpl.html';
import detailsMessagesTemplateUrl from './views/pages/details/messages.tpl.html';
import detailsCheckInsTemplateUrl from './views/pages/details/checkins.tpl.html';
import detailsChangelogTemplateUrl from './views/pages/details/changelog.tpl.html';
import editorPageTemplateUrl from './views/pages/editor.tpl.html';
import importTemplate from './views/pages/import.tpl.html';
import changelogTemplate from './views/pages/changelog.tpl.html';
import duplicateViewTemplateUrl from './views/pages/duplicate.tpl.html';
import duplicatesViewTemplateUrl from './views/pages/duplicates.tpl.html';

angular
    .module('festzelt-os.modules.contacts')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.contacts', {
            abstract: true,
            url: '/contacts',
            template: '<ui-view/>'
        })
        .state('app.contacts.index', {
            url: '',
            controller: ContactsListPageController,
            controllerAs: 'vm',
            data: {
                bodyClass: 'wide',
                right: 'addressbook::list'
            },
            templateUrl: listTemplateUrl
        })
        .state('app.contacts.duplicates', {
            url: '/duplicates',
            controller: ContactsDuplicatesPageController,
            controllerAs: 'vm',
            data: {
                bodyClass: 'wide',
                right: 'addressbook::duplicates'
            },
            templateUrl: duplicatesViewTemplateUrl
        })
        .state('app.contacts.duplicate', {
            url: '/duplicates/{id}',
            controller: ContactsDuplicatePageController,
            controllerAs: 'vm',
            data: {
                rights: 'addressbook::duplicates'
            },
            templateUrl: duplicateViewTemplateUrl
        })
        .state('app.contacts.create', {
            url: '/create',
            controller: ContactsCreatePageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::create'
            },
            templateUrl: editorPageTemplateUrl
        })
        .state('app.contacts.multi-edit', {
            url: '/multi-edit',
            controller: ContactsMultipleEditPageController,
            controllerAs: 'vm',
            params: {
                store: {
                    type: 'any',
                    value: null
                }
            },
            data: {
                right: 'addressbook::create'
            },
            templateUrl: editorPageTemplateUrl
        })
        .state('app.contacts.edit', {
            url: '/{id}/edit',
            controller: ContactsEditPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::edit'
            },
            templateUrl: editorPageTemplateUrl
        })
        .state('app.contacts.details', {
            abstract: true,
            url: '/{id}',
            params: {
                id: {
                    type: 'int',
                    dynamic: true,
                    inherit: true
                },
                contact: {
                    type: 'any',
                    value: null,
                    dynamic: true,
                    inherit: true
                }
            },
            data: {
                right: 'addressbook::view'
            },
            templateUrl: detailsBaseTemplateUrl
        })
        .state('app.contacts.details.overview', {
            url: '/overview',
            controller: ContactsDetailsOverviewPageController,
            controllerAs: 'vm',
            templateUrl: detailsOverviewTemplateUrl
        })
        .state('app.contacts.details.documents', {
            url: '/documents',
            controller: ContactsDetailsDocumentsPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::documents'
            },
            templateUrl: detailsDocumentsTemplateUrl
        })
        .state('app.contacts.details.invoices', {
            url: '/invoices',
            controller: ContactsDetailsInvoicesPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::invoices'
            },
            templateUrl: detailsInvoicesTemplateUrl
        })
        .state('app.contacts.details.rsvps', {
            url: '/rsvps',
            controller: ContactsDetailsRsvpsPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::rsvps'
            },
            templateUrl: detailsRsvpsTemplateUrl
        })
        .state('app.contacts.details.messages', {
            url: '/messages',
            controller: ContactsDetailsMessagesPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::messages'
            },
            templateUrl: detailsMessagesTemplateUrl
        })
        .state('app.contacts.details.checkins', {
            url: '/checkins',
            controller: ContactsDetailsCheckInsPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::checkins'
            },
            templateUrl: detailsCheckInsTemplateUrl
        })
        .state('app.contacts.details.changelog', {
            url: '/changelog',
            controller: ContactsDetailsChangelogPageController,
            controllerAs: 'vm',
            data: {
                right: 'addressbook::changelog'
            },
            templateUrl: detailsChangelogTemplateUrl
        })
        .state('app.contacts.import', {
            url: '/import',
            data: {
                rights: 'addressbook::import'
            },
            templateUrl: importTemplate,
            controller: ContactsImportPageController,
            controllerAs: 'vm'
        })
        .state('app.contacts.changelog', {
            url: '/changelog',
            data: {
                rights: 'addressbook::changelog'
            },
            templateUrl: changelogTemplate,
            controller: ContactsChangelogPageController,
            controllerAs: 'vm'
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/routes.js